import {
  TIME_TAB_RESET,
  appParentConstants,
  filtersConfigReducer,
  userRoleAccessReducer,
  appConfigReducer,
  notificationReducer,
  SET_SHOW_SNACKBAR,
  ROLE_CALLOUT_SHOWN,
  CHANGE_TAB,
  COMING_BACK_FROM_DETAIL_PAGE,
} from "./redux";
import { getPreviousState } from "src/shared/utils";
import { TimeTabs } from "src/shared/types";
import { IAction } from "src/store";
import { augmentReducer } from "src/store/utils";
import { AppState } from "./types";

/**Feature to reset the time tab on session close*/
const initialState = {
  selectedTab: sessionStorage.getItem(TIME_TAB_RESET)
    ? getPreviousState("app.selectedTab") || TimeTabs.TODAY
    : TimeTabs.TODAY,
  shouldShowSnackbar: false,
  isRoleCalloutShown: !!localStorage.getItem(ROLE_CALLOUT_SHOWN),
  comingBackFromDetailsPage: false,
};

const appReducer = (state = initialState, { type, payload }: IAction<symbol | string, string>) => {
  switch (type) {
    case appParentConstants.get(CHANGE_TAB):
      return { ...state, selectedTab: payload };
    case appParentConstants.get(SET_SHOW_SNACKBAR):
      return { ...state, shouldShowSnackbar: payload };
    case appParentConstants.get(ROLE_CALLOUT_SHOWN):
      return { ...state, isRoleCalloutShown: payload };
    case appParentConstants.get(COMING_BACK_FROM_DETAIL_PAGE):
      return { ...state, comingBackFromDetailsPage: payload };
    default:
      return state;
  }
};

export default augmentReducer<AppState, IAction<symbol, any>>(appReducer)({
  filtersConfig: filtersConfigReducer,
  userRoles: userRoleAccessReducer,
  appConfig: appConfigReducer,
  notification: notificationReducer,
});
